const routes = [
  {
    path: '/student/DisciplineCertification',
    component: () => import('@/views/student/DisciplineCertification/Wrapper'),
    children: [
      {
        path: '',
        name: 'DisciplineCertificationHistory',
        component: () =>
          import('@/views/student/DisciplineCertification/Main.vue'),
      },
      {
        path: 'add',
        name: 'AddCertificationDiscipline',
        component: () =>
          import(
            '@/views/student/DisciplineCertification/AddCertification.vue'
          ),
      },
      {
        path: '/student/DisciplineCertificationHistory/information',
        name: 'DisciplineInformation',
        component: () =>
          import(
            '@/views/student/DisciplineCertification/InformationCertification.vue'
          ),
      },
    ],
  },
];

export default routes;
